<template>
	<form>
		<div class="d-flex flex-row nowrap justify-content-between mb-3 heading">
			<span>{{ t("loginRegister.user_info_forgot_password") }}</span>
		</div>

		<div ref="emailwrapper" class="mb-3">
			<TextInput
				:disabled="true"
				:value="email"
				:placeholder="t('loginRegister.contacts_email')"
				:type="'email'"
			/>
		</div>

		<div class="caption">
			<span>{{ t("loginRegister.user_info_enter_email") }}</span>
		</div>

		<div class="my-4">
			<Button :disabled="!email" @buttonClick="(e) => handleButtonClick(e)">
				<template #text>
					<span>{{ t("loginRegister.send") }}</span>
				</template>
			</Button>
		</div>
	</form>
</template>

<script lang="ts" setup>
import {
	reactive,
	defineProps,
	defineEmits,
	onMounted,
	onBeforeUnmount,
	ref,
} from "vue"

import { onKeyStroke } from "@vueuse/core"

// common components
import TextInput from "@/components/LoginRegister/common/inputs/Text/v1/Text.vue"
import Button from "@/components/LoginRegister/common/Button/v1/Button.vue"

// logic
import resetPassword from "@/logic/contact/resetPassword"

// composables
import useLoading from "@/composables/useLoading"

// state
import email from "@/state/email"
import loggedInUser from "@/state/loggedInUser"

// Translations
import { useI18n } from 'vue-i18n'
const {t} = useI18n()

// utils
import {getQueryParams} from "@/utils"

interface Emits {
	(e: "emailSent"): void
}



const emailwrapper = ref()

// query params
const queryParams = getQueryParams()

// emit
const emit = defineEmits<Emits>()

// handlers
const handleButtonClick = async () => {
	const { startLoadingThis, stopLoadingThis } = useLoading()
	startLoadingThis()
	await resetPassword()
	emit("emailSent")
	stopLoadingThis()
}

onMounted(() => {
	// onKeyStroke
	const stop = onKeyStroke("Enter", () => {
		if (!email.value) return
		handleButtonClick()
	})
	onBeforeUnmount(() => stop())

	emailwrapper.value.querySelector("input").focus()
})
</script>

<style  scoped></style>
